import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaptopFlash = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.59 15.27a4 4 0 0 1 -1.34 0.23 3.1 3.1 0 0 1 -2.95 -1.65 0.49 0.49 0 0 0 -0.47 -0.36H0.75a0.48 0.48 0 0 0 -0.41 0.22 0.47 0.47 0 0 0 -0.05 0.47 5.43 5.43 0 0 0 5 3.31H12a0.26 0.26 0 0 0 0.25 -0.26 2.36 2.36 0 0 1 0.56 -1.64 0.21 0.21 0 0 0 0 -0.25 0.19 0.19 0 0 0 -0.22 -0.07Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 12a1 1 0 0 0 1 -1V3a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v4.63a0.25 0.25 0 0 0 0.13 0.22 0.27 0.27 0 0 0 0.26 0 2 2 0 0 1 1.33 -0.32 0.31 0.31 0 0 0 0.2 -0.07 0.23 0.23 0 0 0 0.08 -0.18V3a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8a1 1 0 0 0 1 1Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.67 15.51a0.87 0.87 0 0 0 -0.79 -0.51H21a0.25 0.25 0 0 1 -0.25 -0.25V9.5a0.5 0.5 0 0 0 -0.89 -0.31L14 16.56a0.87 0.87 0 0 0 0.63 1.44h1.87a0.25 0.25 0 0 1 0.25 0.25v5.25a0.51 0.51 0 0 0 0.34 0.47 0.45 0.45 0 0 0 0.16 0 0.51 0.51 0 0 0 0.39 -0.19l5.9 -7.37a0.88 0.88 0 0 0 0.13 -0.9Z",
			fill: "currentColor",
			strokeWidth: 1
		})
	] })
});
export { SvgLaptopFlash as ReactComponent };
